import Component from '../classes/Component'
import { Howl, Howler } from 'howler'
import Approaching from '../../sounds/approaching-be-still-the-earth.mp3'
import SchoolSinging from '../../sounds/school-and-singing-compressed.mp3'
import KidsPlaying from '../../sounds/kids-playing-compressed.mp3'
import Tick from '../../sounds/tick.mp3'

export default class extends Component {
  constructor (scrollbar) {
    super({
      classes: {},
      element: 'body',
      elements: {
        nav: '.nav'
      }
    })
    this.create()
  }

  create () {
    this.background = new Howl({
      src: Approaching,
      autoplay: false,
      loop: true,
      volume: 0.02
    })
    this.kids1 = new Howl({
      src: SchoolSinging,
      autoplay: false,
      loop: false,
      volume: 0.1
    })
    this.kids2 = new Howl({
      src: KidsPlaying,
      autoplay: false,
      loop: false,
      volume: 0.3
    })
    this.tick = new Howl({
      src: Tick,
      autoplay: false,
      loop: false,
      volume: 0.4
    })
  }

  playBackground () {
    this.background.play()
  }

  pauseBackground () {
    this.background.pause()
  }

  mute () {
    Howler.mute(true)
  }

  unmute () {
    Howler.mute(false)
  }

  playSchoolAndSinging () {
    if (!this.kids1.playing()) {
      this.kids1.play()
    }
  }

  playKidsPlaying () {
    if (!this.kids2.playing()) {
      this.kids2.play()
    }
  }

  playTick () {
    this.tick.play()
  }

  dampen (shouldDampen) {
    if (shouldDampen) {
      Howler.volume(0)
    } else {
      Howler.volume(1)
    }
  }
}
